import request from '../_helpers/request';
import axios from 'axios'; 

export const reportService = {
    GetReportEditions,
    GetTrafficReport_Grid,
    Report_SupplierReport_GetSupplierSpecificReportData,
    Report_SupplierReport_GetUniversalData,
    Report_SupplierReport_GetSystemData,
    UploadExcel,
    GetReportsListByBack,
    MarkReportStatus,
    SendReportEmail
};

const TrafficReportAPI = "TrafficReport";

function GetReportEditions() {
    return request({
        url: `${TrafficReportAPI}/GetReportEditions`,
        method: 'get'
        // ,params: query
    });
}

function GetReportsListByBack(query) {
    return request({
        url: `${TrafficReportAPI}/GetReportsListByBack`,
        method: 'post'
        ,data: query
    });
}


function GetTrafficReport_Grid(query){
    return request({
        url: `${TrafficReportAPI}/GetTrafficReport_Grid`,
        method: 'post'
        ,data: query
    });
}

function Report_SupplierReport_GetSupplierSpecificReportData(query){
    return request({
        url: `${TrafficReportAPI}/Report_SupplierReport_GetSupplierSpecificReportData`,
        method: 'post'
        ,data: query
    });
}

function Report_SupplierReport_GetUniversalData(query){
    return request({
        url: `${TrafficReportAPI}/Report_SupplierReport_GetUniversalData`,
        method: 'post'
        ,data: query
    });
}

function Report_SupplierReport_GetSystemData(query){
    return request({
        url: `${TrafficReportAPI}/Report_SupplierReport_GetSystemData`,
        method: 'post'
        ,data: query
    });
}

function UploadExcel(query){
    return request({
        url: `${TrafficReportAPI}/UploadExcel`,
        method: 'post'
        ,data: query,
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

function MarkReportStatus(query){
    return request({
        url: `${TrafficReportAPI}/MarkReportStatus`,
        method: 'post'
        ,data: query

    })
}

function SendReportEmail(query){
    return request({
        url: `${TrafficReportAPI}/SendReportEmail`,
        method: 'post'
        ,data: query
    }) 
}